import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/chat',
            name: 'chat',
            component: () => import("./views/chat.vue"),
            meta: {
                hasBar: true
            }
        },
        {
            path: '/chat/:identifier',
            name: 'chatDetail',
            component: () => import("./views/chatDetail.vue"),
        },
    ];
};